import { Dispatch, FC, SelectHTMLAttributes, useContext } from 'react';
import { DashboardContext } from '../DashboardContext';
import { Site } from '../../sites/dto/Site';
import './DashboardTableSiteSelect.scss';

export const DashboardTableSiteSelect: FC<
  SelectHTMLAttributes<HTMLSelectElement> & {
    onSiteSelect: Dispatch<Site>;
    placeholder: string;
    selectedSiteId?: string | null;
  }
> = ({ placeholder, onSiteSelect, selectedSiteId, ...attrs }) => {
  const { data = [] } = useContext(DashboardContext).sites;

  return (
    <select
      className="DashboardTableSiteSelect"
      onChange={(event) => {
        const id = event.target.value;

        if (id) {
          const site = data.find((site) => site.id === id);

          if (site) {
            onSiteSelect(site);
          }
        }
      }}
      value={selectedSiteId || ''}
      {...attrs}
    >
      <option disabled value="">
        {placeholder}
      </option>

      {data.map((site) => (
        <option value={site.id} key={site.id}>
          {site.name}
        </option>
      ))}
    </select>
  );
};
